import { atlassianStore as store } from 'src/utils/store';

const LAST_REVIEWED_COMMIT_KEY = 'last-reviewed-commit';

export const updateLastReviewedCommit = (
  commitHash: string | null,
  owner: string,
  slug: string,
  id: string | number | undefined
): void => {
  if (!commitHash || !id) {
    return;
  }

  // store in local storage
  const key = `${LAST_REVIEWED_COMMIT_KEY}:${owner}/${slug}/${id}`;
  const sevenDayExpiry = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
  store.setStrictlyNecessaryItem(key, commitHash, sevenDayExpiry);
};

export const getLastReviewedCommit = (
  owner: string,
  slug: string,
  id: string | number | undefined
): string => {
  if (!id) {
    return '';
  }

  // fetch from local storage
  const key = `${LAST_REVIEWED_COMMIT_KEY}:${owner}/${slug}/${id}`;
  const localStorageValue = store.get(key);
  return localStorageValue;
};

export const getCommitMessage = (commit: BB.Commit): string => {
  const newlineOrTabRegex = /[\n\r\t]+/g;
  const renderedMessage =
    (commit.rendered && commit.rendered.message) || commit.summary;
  return (
    renderedMessage?.raw.replace(newlineOrTabRegex, ' ') ||
    commit.message.replace(newlineOrTabRegex, ' ')
  );
};
